import React from "react";
import { CircularProgress, Box } from "@mui/material";

const Loader = ({ color = "primary", size = 40, thickness = 3.6 }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="70vh"
      width="70vw"
    >
      <CircularProgress color={color} size={size} thickness={thickness} />
    </Box>
  );
};

export default Loader;
